// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__1IHKM","name":"ConsentHeader_name__2I-_x","birthday":"ConsentHeader_birthday__2h_Gl","skeleton":"ConsentHeader_skeleton__2aHSe"};